// 契約の部門（#3431）: 現場の主部門と別の事業本部の部門を選んだ瞬間にエラーを出し、選択を元に戻す。
// select は data-contract-business-unit、許可する事業本部 id は data-allowed-division-id、
// 各 option は data-division-id を持つ（contracts_helper#contract_business_unit_v2_options）。
// モーダル内で後から描画されるので document に委譲する。
(function () {
  const SELECTOR = 'select[data-contract-business-unit]';

  function rememberCurrent(select) {
    select.dataset.previousValue = select.value;
  }

  function errorSpan(select) {
    const field = select.closest('.field');
    return field ? field.querySelector('[id$="-error"] span') : null;
  }

  document.addEventListener('focusin', (event) => {
    const select = event.target.closest(SELECTOR);
    if (select) rememberCurrent(select);
  });

  document.addEventListener('change', (event) => {
    const select = event.target.closest(SELECTOR);
    if (!select) return;

    const allowed = select.dataset.allowedDivisionId;
    const option = select.selectedOptions[0];
    const chosen = option ? option.dataset.divisionId : '';
    const span = errorSpan(select);

    if (!allowed || !chosen || chosen === allowed) {
      if (span) span.textContent = '';
      rememberCurrent(select);
      return;
    }

    if (span) span.textContent = select.dataset.otherDivisionMessage || '';
    select.value = select.dataset.previousValue || '';
  });
})();
